import { useState } from "react";
import WeatherConfidenceBadge from "./WeatherConfidenceBadge";

const WeatherRiskEvidenceList = ({ evidence }) => {
  const [expanded, setExpanded] = useState(false);

  if (!evidence) {
    return null;
  }

  const rainGauges = evidence.rainGauges || [];
  const quebradaLevels = evidence.quebradaLevels || [];
  const alerts = evidence.alerts || [];

  return (
    <section className="weather-risk-evidence">
      <button
        type="button"
        className="weather-risk-evidence__toggle"
        onClick={() => setExpanded((value) => !value)}
        aria-expanded={expanded}
      >
        {expanded ? "Hide nearby observations" : "Show nearby observations"}
      </button>

      {expanded ? (
        <div className="weather-risk-evidence__body">
          <h4>Nearby observations</h4>
          {rainGauges.length ? (
            <ul>
              {rainGauges.slice(0, 5).map((gauge) => (
                <li key={`${gauge.stationName}-${gauge.observedAt}`}>
                  Rain gauge: {gauge.stationName || "SIATA station"}
                  {gauge.valueNumeric != null ? ` · ${gauge.valueNumeric} ${gauge.unit || "mm"}` : ""}
                  {gauge.distanceM != null ? ` · ${Math.round(gauge.distanceM)} m` : ""}
                </li>
              ))}
            </ul>
          ) : (
            <p className="muted">No rain gauge observations within search radius.</p>
          )}

          {quebradaLevels.length ? (
            <ul>
              {quebradaLevels.slice(0, 3).map((sensor) => (
                <li key={`${sensor.stationName}-${sensor.observedAt}`}>
                  Quebrada: {sensor.stationName || "Sensor"}
                  {sensor.status ? ` · ${sensor.status}` : ""}
                  {sensor.distanceM != null ? ` · ${Math.round(sensor.distanceM)} m` : ""}
                </li>
              ))}
            </ul>
          ) : (
            <p className="muted">No quebrada level sensors within search radius.</p>
          )}

          <h4>Active alerts</h4>
          {alerts.length ? (
            <ul>
              {alerts.slice(0, 5).map((alert) => (
                <li key={`${alert.title}-${alert.issuedAt || alert.distanceM}`}>
                  {alert.title || "Alert"}
                  {alert.severity ? ` · ${alert.severity}` : ""}
                  {alert.distanceM != null ? ` · ${Math.round(alert.distanceM)} m` : ""}
                </li>
              ))}
            </ul>
          ) : (
            <p className="muted">No active alerts within search radius.</p>
          )}

          {evidence.airQuality?.length ? (
            <>
              <h4>Air quality</h4>
              <p className="muted">{evidence.airQuality.length} station(s) in range.</p>
            </>
          ) : null}

          {evidence.satellite?.available ? (
            <>
              <h4>Satellite estimate</h4>
              <p className="muted">
                Satellite rain estimate
                {evidence.satellite.frameTime
                  ? ` · ${new Date(evidence.satellite.frameTime).toLocaleString()}`
                  : ""}
              </p>
              <p className="muted">Estimate, not radar.</p>
            </>
          ) : null}
        </div>
      ) : null}
    </section>
  );
};

export { WeatherConfidenceBadge as WeatherRiskConfidenceBadge };

export default WeatherRiskEvidenceList;
